{
  "entities": {
    "warehouses": "คลังสินค้า | คลังสินค้า",
    "loadtypes": "ประเภทสินค้า | ประเภทสินค้า",
    "organizations": "องค์กร | องค์กร",
    "orgs": "องค์กร | องค์กร"
  }
}
